@if(formData?.target || formData?.launchUrl) {
    @if (formData.launchUrl) {
        <a [href]="formData.launchUrl" class="external-link" id="formSubmit" target="_blank">{{ buttonText }}</a>
    } @else {
        <a [href]="formData.target" class="external-link" id="formSubmit" target="_blank">{{ buttonText }}</a>
    }
} @else if (formData?.url) {
    <form #submitForm (submit)="onSubmit()"
          [attr.action]="formData.url"
          [attr.id]="id"
          [attr.method]="formData.method"
          [target]="isEduvidual() ? 'eduvidual-login' : '_blank'">
        @if (formData.params.user_id) {
            <input [value]="formData.params.user_id" name="user_id" type="hidden">
        }
        @if (formData.params.product_id) {
            <input [value]="formData.params.product_id" name="product_id" type="hidden">
        }
        <input [value]="formData.params.oauth_callback" name="oauth_callback" type="hidden">
        <input [value]="formData.params.oauth_consumer_key" name="oauth_consumer_key"
               type="hidden">
        <input [value]="formData.params.oauth_nonce" name="oauth_nonce" type="hidden">
        <input [value]="formData.params.oauth_signature" name="oauth_signature" type="hidden">
        <input [value]="formData.params.oauth_signature_method" name="oauth_signature_method"
               type="hidden">
        <input [value]="formData.params.oauth_timestamp" name="oauth_timestamp" type="hidden">
        <input [value]="formData.params.oauth_version" name="oauth_version" type="hidden">
        <!-- eSquirrel and GMT -->
        @if (formData.params.code) {
            <input [value]="formData.params.code" name="code" type="hidden">
        }
        @if (formData.params.isbn) {
            <input [value]="formData.params.isbn" name="isbn" type="hidden">
        }
        @if (formData.params.target) {
            <input [value]="formData.params.target" name="target" type="hidden">
        }
        <!-- LTI -->
        @if (isEduvidual()) {
            <input [value]="formData.params.id" name="id" type="hidden">
        }
        @if (formData.params.lti_message_type) {
            <input [value]="formData.params.lti_message_type" name="lti_message_type"
                   type="hidden">
        }
        @if (formData.params.lti_version) {
            <input [value]="formData.params.lti_version" name="lti_version" type="hidden">
        }
        @if (formData.params.resource_link_id) {
            <input [value]="formData.params.resource_link_id" name="resource_link_id"
                   type="hidden">
        }
        @if (formData.params.theme) {
            <input [value]="formData.params.theme" name="theme"
                   type="hidden">
        }
        @if (formData.params.license_type) {
            <input [value]="formData.params.license_type" name="license_type" type="hidden">
        }
        @if (formData.params.roles) {
            <input [value]="formData.params.roles" name="roles" type="hidden">
        }
        @if (formData.params.custom_code) {
            <input [value]="formData.params.custom_code" name="custom_code" type="hidden">
        }
        @if (formData.params.context_id) {
            <input [value]="formData.params.context_id" name="context_id" type="hidden">
        }
        <!-- Yedo -->
        @if (formData.params.custom_yedo) {
            <input [value]="formData.params.custom_yedo" name="custom_yedo" type="hidden">
        }
        <!-- Phase6 -->
        @if (formData.params.partner) {
            <input [value]="formData.params.partner" name="partner" type="hidden">
        }
        <!-- CalcuFlow -->
        @if (formData.params.custom_worksheet_id) {
            <input [value]="formData.params.custom_worksheet_id" name="custom_worksheet_id" type="hidden">
        }
        @if (formData.params.custom_assignments) {
            <input [value]="formData.params.custom_assignments" name="custom_assignments" type="hidden">
        }
        @if (formData.params.custom_worksheet_updated_at) {
            <input [value]="formData.params.custom_worksheet_updated_at" name="custom_worksheet_updated_at" type="hidden">
        }
        <input [value]="buttonText" class="external-link" id="formSubmit" type="submit">
    </form>
}

@if (formData.url && isEduvidual()) {
    <iframe
            (load)="onIFrameLoad($event)"
            height="1px"
            id="eduvidualIframe"
            name="eduvidual-login" src="https://www.eduvidual.at/local/eduvidual/pages/login.php"
            width="1px"></iframe>
}


@if (!formData) {
    <p>Bitte warten...</p>
}
